module.exports = __webpack_public_path__ + "static/media/IFB.d829c535.svg";